export default __webpack_public_path__ + "static/media/qhb-2.8ddc029c.png";